/**
 * Accumulates one streaming text chunk onto the running content of a block.
 *
 * Both shapes have to be tolerated because the producers disagree, and a
 * single block_id carries whichever its producer sends:
 *   - agent nodes emit incremental deltas (`delta.content_delta`), so the
 *     default is to append;
 *   - general chat re-sends the whole round each frame, so a chunk that is a
 *     superset of what we have replaces it rather than doubling it.
 * An identical chunk is a re-sent snapshot and is ignored.
 *
 * Critically, a substring check must NOT be used to dedup: short deltas such
 * as a lone whitespace chunk are almost always already present in the
 * accumulated text, so dropping them silently fuses adjacent words
 * ("domestic demand" -> "domesticdemand"). A *prefix* check is narrow enough
 * to be safe, since it only fires when the running text opens with exactly the
 * incoming chunk — the shape of a stale snapshot, not of a mid-text delta.
 */
export const accumulateStreamingText = (
  current: string,
  incoming: string,
): string => {
  if (!incoming || current === incoming) return current;
  if (incoming.startsWith(current)) return incoming;
  // An older snapshot arriving after a newer one; appending would repeat the
  // opening text ("Hello world" + "Hello" -> "Hello worldHello").
  if (current.startsWith(incoming)) return current;
  return current + incoming;
};
